import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/view/layout/index'
import Home from '@/view/home/ModernHome'
import ProductList from '@/view/product/ProductList'
import ProductDetail from '@/view/product/ProductDetail'
import CompanyInfo from '@/view/company/CompanyInfo'
import ContactInfo from '@/view/company/ContactInfo'
import SolutionsPage from '@/view/solution/SolutionsPage'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '',
          name: 'home',
          component: Home,
          meta: { title: '主页' }
        },
        {
          path: 'products',
          name: 'products',
          component: ProductList,
          meta: { title: '产品中心' }
        },
        {
          path: 'product/:id',
          name: 'product-detail',
          component: ProductDetail,
          meta: { title: '产品详情' }
        },
        {
          path: 'company',
          name: 'company',
          component: CompanyInfo,
          meta: { title: '关于我们' }
        },
        {
          path: 'contact',
          name: 'contact',
          component: ContactInfo,
          meta: { title: '联系方式' }
        },
        {
          path: 'solutions',
          name: 'solutions',
          component: SolutionsPage,
          meta: { title: '解决方案' }
        }
      ]
    },
    { path: '/product/product', redirect: '/products' },
    { path: '/contact/contact', redirect: '/contact' }
  ]
  // mode: 'history'
})
